












































import { Component, Vue } from 'vue-property-decorator';
import ApplicationLayout from '@/layouts/ApplicationLayout.vue';
import EmptyLayout from '@/layouts/EmptyLayout.vue';
import Locale from '@/utils/locale';
import SWAppUpdate from './components/SWAppUpdate.vue';
import AppLoader from './components/AppLoader.vue';
import FontLoader from '@/components/FontLoader.vue';
import * as isTabDown from '@/components/UI/IsTabDown';
import js404handler from '@/utils/js-404-handler';

@Component({
  components: {
    SWAppUpdate,
    AppLoader,
    FontLoader,
  },
})
export default class App extends Vue {
  private defaultLayout = ApplicationLayout;

  private mounted() {
    isTabDown.init();
    if (js404handler.hasJustReloaded) {
      this.showPageJustReloadedWarning = true;
    }
  }

  private showPageJustReloadedWarning = false;

  get layout() {
    if (this.$route.name === null) {
      return EmptyLayout;
    }
    return this.$route.meta.layout || this.defaultLayout;
  }


  get skipApplicationLoader() {
    return (
      // Add query param skipApplicationLoader=true to not show application loader
      this.$route.query.skipApplicationLoader === 'true' ||
      // Skip application loader, we don't want to make APPLICATION_USER_DATA query request,
      // which return unauthorized and redirected to login page
      this.layout.name === 'EmptyLayout'
    );
  }

  // When the page is refreshed, the router gets the first route to be { name: null, path: '/' }
  // This means it cannot read query params, and might cause trouble in general.
  // With this getter, we make sure that the received route is named - exists,
  // as all our routes are, and can proceed with rendering the template.
  get routesLoaded() {
    return this.$route.name !== null;
  }

  private setNewLocale() {
    const newLocale = Locale.get();
      if (newLocale && newLocale !== this.$i18n.locale) {
        this.$i18n.locale = newLocale;
    }
  }
}
